<template>
  <div>
    <MainNavigation :routeIndex="routeIndex"/>
    <NotificationBar
      msg-text="Welcome to the Unsung teacher dashboard. Let’s review your Profile to get started."
    />
    <div>
      <h3>My Account</h3>
      <p>What do your students call you in the classroom?</p>
      <div class="flex-container-row ">
        <input
          id="teacherName-input"
          v-model="teacherName"
          placeholder="Ms. Hooks"
          required
        />
        <span><strong>*Required</strong></span>
        </div>
      <div>
        <button @click="send" type="button"><span>Next</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import NotificationBar from "../components/NotificationBar.vue";
export default {
  name: "Account",
  conn: null,
  data() {
    return {
      teacherName: "",
    };
  },
  props: ["routeIndex"],
  components: {
    MainNavigation,
    NotificationBar,
  },
  methods: {
    send: function () {
      this.$store.commit("SEND_MESSAGE", {
        data: this.teacherName,
        opCode: this.$store.state.opCodes.SetTeacherName,
      });
      this.$store.dispatch("setTeacherName", this.teacherName);
      this.$router.push({ name: "tutorial" });
    },
  },
};
</script>

<style>
</style>